import styled from "styled-components";

export const Container = styled.div`
  min-width: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;

  @media (max-width: 600px) {
    min-width: auto;
    flex-direction: column;
  }
`;

export const ListContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: var(--theme-color-secondary);
  border: 1px solid var(--border-color);
  height: 180px;
  overflow-y: auto;
  border-radius: 10px;

  @media (max-width: 600px) {
    flex: none;
    width: 100%;
    height: 140px;
  }
`;

export const ListContainerHeader = styled.div`
  position: sticky;
  top: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  background-color: var(--theme-color-secondary);
  border-bottom: 1px solid var(--border-color);
  font-size: 14px;
  color: var(--text-color-primary);
  padding: 10px 20px;
`;

export const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  font-size: 14px;
`;

export const ListItem = styled.li`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 6px 16px;
  cursor: pointer;
  border: 1px solid var(--table-border-color);
  background: ${({ selected }) => selected ? 'var(--theme-color-primary)' : 'transparent'};
  color: ${({ selected }) => selected ? 'var(--theme-color-white)' : 'var(--text-color-primary)'};
  &:hover {
    background: ${({ selected }) => selected ? 'var(--theme-color-primary)' : 'var(--table-border-color)'};
  }
  margin: 3px 4px;
  border-radius: 8px;
`;

export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  /* margin-right: 12px; */
`;

export const ButtonColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  @media (max-width: 600px) {
    flex-direction: row;

    button svg {
      transform: rotate(90deg);
    }
  }
`;